import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateReturnOrderManualComponent } from './create-return-order-manual.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { NgxMaskModule } from 'ngx-mask';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PosAddEditProductReturnManualModalModule } from 'src/app/shared/pos-add-edit-product-return-manual-modal/pos-add-edit-product-return-manual-modal.module';



@NgModule({
  declarations: [CreateReturnOrderManualComponent],
  imports: [
    CommonModule,
    AccordionModule,
    FormsModule,
    NgSelectModule,
    PosTableModule,
    NgxMaskModule,
    BsDatepickerModule,
    PosAddEditProductReturnManualModalModule,
  ],
  exports: [CreateReturnOrderManualComponent]
})
export class CreateReturnOrderManualModule { }
